export default {
  notifications: { english: "Notifications", spanish: "Notificaciones" },
  logout: { english: "Logout", spanish: "Cerrar sesión" },
  welcome: { english: "Welcome", spanish: "Bienvenidos" },
  myProfile: { english: "My Profile", spanish: "Mi perfil" },
};
